import { Box, Icon, css, Text, Grid } from "@storyofams/react-ui";
import { CrueltyFree } from "~components/common/Icons/Product/cruelty-free";
import { Natural } from "~components/common/Icons/Product/natural";
import { Organic } from "~components/common/Icons/Product/organic";
import { PlasticFree } from "~components/common/Icons/Product/plastic-free";
import { Unrefined } from "~components/common/Icons/Product/unrefined";
import { Vegan } from "~components/common/Icons/Product/vegan";
import { WaterFree } from "~components/common/Icons/Product/water-free";

const defaultIcons = [
  {
    title: "100% Natuurlijk",
    icon: "natural",
  },
  {
    title: "Vegan",
    icon: "vegan",
  },
  {
    title: "Proefdiervrij",
    icon: "cruelty-free",
  },
  {
    title: "Plastic-vrij",
    icon: "plastic-free",
  },
  {
    title: "Biologisch",
    icon: "organic",
  },
  {
    title: "Ongeraffineerd",
    icon: "unrefined",
  },
];

const getIcon = (icon) => {
  switch (icon) {
    case "natural":
      return Natural;
    case "organic":
      return Organic;
    case "cruelty-free":
      return CrueltyFree;
    case "plastic-free":
      return PlasticFree;
    case "unrefined":
      return Unrefined;
    case "vegan":
      return Vegan;
    case "water-free":
      return WaterFree;
    default:
      return Natural;
  }
};

export const Icons = ({ content, ...props }) => {
  const icons = content && content.length ? content : defaultIcons;
  return (
    <Box {...props} my={["24px", "30px"]}>
      <Grid rowSize={[3, 6]}>
        {icons?.map(({ _uid, title, icon }, i) => (
          <Box textAlign="center" key={_uid} mt={i > 2 ? ["18px", 0] : 0}>
            <Icon
              height={60}
              width={60}
              css={css({ svg: { width: "100%", height: "100%" } })}
              icon={getIcon(icon)}
            />
            <Text fontSize={"14px"} fontWeight="400" mt={"6px"}>
              {title}
            </Text>
          </Box>
        ))}
      </Grid>
    </Box>
  );
};
